// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__uXT5X","namePhoneContainer":"style_namePhoneContainer__LXTmi"};